import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lmsCheckNoData'
})
export class CheckNoDataPipe implements PipeTransform {
  constructor() {}

  transform(value: number, ...args: any[]): boolean {
    // 0 is still a value, we only check value is not undefined or null
    return value != null;
  }
}
